var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-expansion-panels',{attrs:{"focusable":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('scroll-list',{attrs:{"items":_vm.ids,"pageSize":20},scopedSlots:_vm._u([{key:"list-item",fn:function({ item: id }){return [_c('individual-list-item',{attrs:{"id":id,"highlights":_vm.highlights}})]}}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }